export default "__VITE_ASSET__CWsFtgqe__"